export default "__VITE_ASSET__DO$E7LXg__"